// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"InfluencerUgcVideoModal_videoWrapper__ra_4X","video":"InfluencerUgcVideoModal_video__zqwcj"};